import { FunctionComponent } from 'react';
import { toString } from 'es-toolkit/compat';

import { Radiobutton, RadiobuttonGroup } from '@tock/shared/inputs';
import { consumer } from '@tock/coretypes';

export interface Props {
  question: consumer.IPatronQuizQuestion;
  selectedOptionId?: number;
  onAnswer(optionId: number[]): void;
}

const TextSelectQuizQuestion: FunctionComponent<Props> = ({
  question,
  selectedOptionId,
  onAnswer,
}) => {
  return (
    <RadiobuttonGroup>
      {question.option?.map((option) => {
        if (!option.id) {
          return;
        }
        const isSelected = selectedOptionId === option.id;
        return (
          <Radiobutton
            name={toString(question.id) || undefined}
            onChange={() => option.id && onAnswer([option.id])}
            checked={isSelected}
            className="QuizModal-textQuestionOption"
            label={option.displayText || ''}
            key={`TextSelect-option-${option.id}`}
          />
        );
      })}
    </RadiobuttonGroup>
  );
};

export default TextSelectQuizQuestion;
